import { useEffect, useState } from 'react';

/**
 * One breakpoint for the whole codebase. 767px and below is the phone layout;
 * 768px and up keeps the desktop sidebar.
 */
export const MOBILE_QUERY = '(max-width: 767px)';

const currentlyMatches = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(MOBILE_QUERY).matches;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(currentlyMatches);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (event) => setIsMobile(event.matches);
    mql.addEventListener('change', onChange);
    // Catch a viewport that changed between first render and this effect.
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
